export enum CommunityBaseURL {
  PROD = 'https://community.chaoslabs.xyz',
  STAGING = 'https://community-staging.chaoslabs.xyz',
}
